<template>
    <div id="searchCompany">
      <div>
        <a-input
          :placeholder="$t('customer.searchCompanyModal.searchText')"
          v-model.trim="queryVO.queryText"
          maxlength="30"
          @pressEnter="searchCompany"
        >
        </a-input>
        <div class="searchButtonDiv">
          <a-button icon="search" @click="searchCompany">{{$t('customer.searchCompanyModal.search')}}</a-button>
        </div>
      </div>
      <div class="tableDiv">
        <div class="selectDiv">
          <span class="selectText" v-text="$t('customer.searchCompanyModal.selected')+':'"></span>
          <span class="companyText">{{selectName}}</span>
        </div>
        <div>
          <a-spin :spinning="loading">
            <el-table
              class="companyTable"
              :data="tableData"
              @row-click="rowClick"
            >
              <el-table-column label="" width="65">
                <template slot-scope="scope">
                  <a-radio :value="scope.row.name" :checked="selectName == scope.row.name" @change.native="getTemplateRow(scope.row)">&nbsp;</a-radio>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                align="left"
                show-overflow-tooltip
                :label="$t('customer.searchCompanyModal.companyName')"
                min-width="300">
                <template slot-scope="scope">
                  <div v-text="scope.row.name"></div>
                </template>
              </el-table-column>
              <el-table-column
                prop="operName"
                align="left"
                show-overflow-tooltip
                :label="$t('customer.searchCompanyModal.legalPerson')"
                min-width="100">
              </el-table-column>
              <el-table-column
                prop="startDate"
                align="center"
                :label="$t('customer.searchCompanyModal.establishmentTime')"
                min-width="150">
              </el-table-column>
              <div slot="empty" class="tableEmpty">
                <div class="emptyDiv">
                  <pt-icon type="icon-GroupCopy2" class="typeIcon"></pt-icon>
                  <div class="emptyContent">
                    {{$t('customer.searchCompanyModal.errorTip')}}
                  </div>
                </div>
              </div>
            </el-table>
          </a-spin>
        </div>
      </div>
    </div>
</template>
<script>
    import {queryByText} from '@/api/mine/searchCompany'
    export default {
    components: {
    },
    name: 'searchCompany',
    props:{

    },
    data () {
      return {
        styleObj:"color: #D23F3F;",
        loading:false,
        tableData:[],
        queryVO:{
          queryText:'',

        },
        selectName:"",
        isSelect:false,
        companyDO:{},//公司信息
      }
    },
    watch: {
    },
    computed: {},
    mounted() {
      this.init();
    },
    methods: {
      rowClick(row){
        this.selectName = row.name;
        this.getTemplateRow(row);
      },
      getTemplateRow(row){
        this.companyDO = row;
        this.selectName = row.name
      },
      init(){
        this.searchCompany();
      },
      searchCompany(){
        if(this.queryVO.queryText != null && this.queryVO.queryText != ''){
          this.queryList();
        }
      },
      queryList(){
        this.loading = true
        let this_ = this
        queryByText(this.queryVO.queryText).then(res=>{
          this_.tableData = res.data;
          this_.loading = false
        })
      },
      confirmSelect(){
        if(this.companyDO.name == null || this.companyDO.name == undefined){
          this.companyDO["name"] = this.queryVO.queryText
          this.$emit("confirm",this.companyDO);
        }else{
          this.$emit("confirm",this.companyDO);
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  #searchCompany{
    padding:0 10px;
    .tableEmpty{
      line-height: 20px !important;
      text-align: justify !important;
      .emptyDiv{
        display: flex;flex-direction: row;padding: 80px 0px;
        align-items: center;
        justify-content: center;
        .typeIcon{
          font-size: 35px;
          color: #D23F3F;
        }
        .emptyContent{
          padding-left: 20px;
          color: #D23F3F;font-size: 12px;width: 220px;word-wrap:break-word;
        }
      }
    }
    .searchButtonDiv{
      position: relative;
      left:635px;
      top: -35px;
    }
    .tableDiv{
      .selectDiv{
        margin-top: 25px;
        display: flex;
        flex-direction: row;
        .selectText{
          font-size: 12px;
          color: #BEBEBE;
          letter-spacing: 0;
        }
        .companyText{
          font-size: 12px;
          color: #333333;
          letter-spacing: 0;
        }
      }
    }
    .confirmCheck{
      position: absolute;
      bottom: 15px;
      .checkContent{
        font-size: 12px;color: #D23F3F;letter-spacing: 0;
      }
    }
  }
</style>
<style>
  .companyTable > .el-table td, .el-table th.is-leaf{
    background: #FAFBFC;
    border-bottom: 1px solid #EBEEF5;
  }
  .companyTable > .el-table__body-wrapper is-scrolling-none > .el-table__empty-block{
    background: #FAFBFC !important;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: #FABE00;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #FABE00;
    background: #FABE00;
  }
</style>